import PropTypes from 'prop-types';
import React from 'react';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// constants
import { getHeaderArticles, getProductStatus } from '../../../constants';
import { orderLinesConditionColumnI18nKey } from 'utils/bookCondition';

const ArticlesHeader = ({ articles_texts = {}, lineItems = null, includeProductBookStatus = false }) => {
  const { t } = useTranslation(['backoffice', 'detalle']);
  const header = getHeaderArticles(t, { includeProductBookStatus });

  const productStatusHeaderLabel =
    includeProductBookStatus && lineItems?.length
      ? t(orderLinesConditionColumnI18nKey(lineItems), { ns: 'detalle' })
      : includeProductBookStatus
        ? t(orderLinesConditionColumnI18nKey([]), { ns: 'detalle' })
        : '';

  return (
    <>
      {Object.keys(articles_texts).length > 0 ? header.map(({ size, key }) => (
        <Col md={size} key={key}>
          <label className='span-details'>
            {key === 'book_product_status'
              ? productStatusHeaderLabel
              : ['ean', 'title', 'editorial'].includes(key)
                ? articles_texts['product'][key]
                : key === 'estado'
                  ? getProductStatus(t)[articles_texts[key]].value
                  : articles_texts[key]}
          </label>
        </Col>
      )) : header.map(({ size, name, key }) => (
        <Col md={size} key={key}>
          <label>{key === 'book_product_status' ? productStatusHeaderLabel : name}</label>
        </Col>
      ))}
      {!articles_texts && <Col md={1}>
        <label>{t('delete')}</label>
      </Col>}
    </>
  );
};

ArticlesHeader.propTypes = {
  articles_texts: PropTypes.object,
  lineItems: PropTypes.array,
  includeProductBookStatus: PropTypes.bool,
};
export default ArticlesHeader;
